// extracted by mini-css-extract-plugin
export default {"Modal":"WarningModal_Modal__EY50B","Content":"WarningModal_Content__41aRM","WarningIcon":"WarningModal_WarningIcon__1lWTk","Options":"WarningModal_Options__Iuj7F"};